import React from 'react';

const SeatPinSvg = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Location Pin</title>
        <defs>
            <path
                d="M5.84347826,0 C2.61286957,0 0,2.56262207 0,5.73110368 C0,10.0294314 5.84347826,16.3745819 5.84347826,16.3745819 C5.84347826,16.3745819 11.6869565,10.0294314 11.6869565,5.73110368 C11.6869565,2.56262207 9.07408696,0 5.84347826,0 L5.84347826,0 Z"
                id="path-1"
            />
        </defs>
        <g
            id="Location-Pin"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Color-Copy-3" transform="translate(6.000000, 4.000000)">
                <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                </mask>
                <use
                    id="Mask"
                    stroke="#FFFFFF"
                    fill="#666A73"
                    xlinkHref="#path-1"
                />
                <g id="⌥/c/Default" mask="url(#mask-2)">
                    <g transform="translate(-6.260870, -4.093645)" id="Color">
                        <rect x="0" y="0" width="25" height="25" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default SeatPinSvg;
